import { useEffect } from "react"
import AOS from "aos"
import "aos/dist/aos.css"

import cloudIntegration from "../assets/images/cloud.svg"
import analysisDashboard from "../assets/images/analysis.svg"
import support from "../assets/images/247support.svg"
import adminDashboard from "../assets/images/admin.svg"

const features = [
  {
    title: "Cloud Integration",
    description:
      "Effortlessly connect your business to the cloud with seamless integration, ensuring secure and real-time access to your data across devices.",
    imageUrl: cloudIntegration,
  },
  {
    title: "Analysis Dashboard",
    description:
      "Gain actionable insights with a powerful analysis dashboard featuring detailed charts and graphs to help you make informed decisions.",
    imageUrl: analysisDashboard,
  },
  {
    title: "24 X 7 Support",
    description:
      "Our dedicated team is available 24/7 to provide reliable assistance and ensure your business operations run smoothly anytime, anywhere.",
    imageUrl: support,
  },
  {
    title: "Admin Dashboard",
    description:
      "Manage your operations efficiently with an intuitive admin dashboard, offering real-time insights and complete control at your fingertips.",
    imageUrl: adminDashboard,
  },
]

const Features = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    })
    AOS.refresh()
  }, [])

  return (
    <div id="features" className="py-12 sm:py-16 bg-[#f6f6f6] flex justify-center">
      <div className="max-w-7xl w-full px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8 sm:mb-12 text-center lg:text-left lg:ml-[27px]" data-aos="fade-up">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Why MarketMind?</h1>

          <p className="text-sm sm:text-base lg:text-lg text-gray-900 font-semibold">
            MarketMind is built to make everyone's job in the APMC-business
            easy.
            <br />
            Every person in the APMC ecosystem experiences
            <br />
            increased productivity with MarketMind.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col items-center" data-aos="fade-up" data-aos-delay={index * 200}>
              {/* Feature Card */}
              <div className="relative w-full max-w-[225px] h-[250px] sm:h-[300px] mb-4 rounded-lg overflow-hidden border-black border-2 shadow-lg transform transition-transform duration-300 hover:scale-105">
                <img
                  src={feature.imageUrl || "/placeholder.svg"}
                  alt={feature.title}
                  className="w-full h-full object-contain rounded-lg transform transition-transform duration-500 hover:scale-110"
                />
              </div>

              {/* Feature Content */}
              <div className="text-justify w-full max-w-[225px]">
                <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm sm:text-base text-gray-900 font-semibold">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Features

